module.exports = __webpack_public_path__ + "static/img/01.349801d5.jpg";